import type { Route } from '~/core/router'

import * as bundles from '~/routes/movies/bundles'
import * as details from '~/routes/movies/details'
import * as subcategories from '~/routes/movies/subcategories'
import * as subcategory from '~/routes/movies/subcategory'

export const route: Route = {
  children: [
    {
      path: '/:vodId',
      component: [details.Title, details.MovieDetailsPage],
      init: details.model.init,
      left: details.model.left,
      meta: {
        contentId(params: { vodId: string }) {
          return Number(params.vodId)
        },
      },
    },
    {
      path: '/bundles/:bundleId',
      component: [bundles.Title, bundles.MovieBundlesPage],
      init: bundles.model.init,
      left: bundles.model.left,
    },
    {
      path: [
        '/categories/:categoryId',
        '/categories/:categoryId/subcategories/:subCategoryId',
      ],
      component: [subcategory.Title, subcategory.MovieCategoriesPage],
      init: subcategory.model.initSubCategoryPage,
      left: subcategory.model.left,
    },
    {
      path: '/categories/:categoryId/subcategories',
      component: [subcategories.Title, subcategories.MovieSubCategoriesPage],
      init: subcategories.model.initSubCategoriesPage,
      left: subcategories.model.left,
    },
  ],
}
